import React, {Component, Fragment} from 'react';
import Button from '../Button';
import './SupportUS.scss';

class SupportUS extends Component {
    render() {
        return (
            <Fragment>
                <section className="wtm-supportUS">
                    <div className="container">
                        <h1 className="big-title">후원해 주신 분들</h1>
                        <div className="logo-container">
                            <h2 className="type">부스 후원</h2>
                            <ul className="logo-list">
                                <li className="logo-item">
                                    <img className="img" src="/img/support/gdg.png"
                                         alt="WTM SEOUL 2019 SUPPORTER Google Developer Groups"/>
                                </li>
                                <li className="logo-item">
                                    <img className="img" src="/img/support/wtm19_toss.png"
                                         alt="WTM SEOUL 2019 SUPPORTER TOSS"/>
                                </li>
                            </ul>
                            <ul className="logo-list">
                                <li className="logo-item">
                                    <img className="img img-tf" src="/img/support/wtm19_ridi.png"
                                         alt="WTM SEOUL 2019 SUPPORTER RIDI"/>
                                </li>
                                <li className="logo-item">
                                    <img className="img img-bs" src="/img/support/wtm19_banksalad.png"
                                         alt="WTM SEOUL 2019 SUPPORTER BANKSALAD"/>
                                </li>
                            </ul>
                            <h2 className="type">영상 후원</h2>
                            <ul className="logo-list">
                                <li className="logo-item">
                                    <img className="img img-tf" src="/img/support/wtm-2019-tf.png"
                                         alt="WTM SEOUL 2019 SUPPORTER THINGS FLOW"/>
                                </li>
                                <li className="logo-item">
                                    <img className="img" src="/img/support/wtm19_eandm.png"
                                         alt="WTM SEOUL 2019 SUPPORTER EASY&MORE"/>
                                </li>
                            </ul>
                            <ul className="logo-list">
                                <li className="logo-item">
                                    <img className="img" src="/img/support/jaranda.png"
                                         alt="WTM SEOUL 2019 SUPPORTER JARANDA"/>
                                </li>
                            </ul>
                            <h2 className="type">돌보미 서비스 후원</h2>

                            <ul className="logo-list">
                                <li className="logo-item">
                                    <img className="img" src="/img/support/jaranda.png"
                                         alt="WTM SEOUL 2019 SUPPORTER JARANDA"/>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>
            </Fragment>

        )
    }
};
export default SupportUS;
